import { Observable } from 'rxjs';
import {
  Attrezzatura,
  CreateAttrezzaturaDto,
  UpdateAttrezzaturaDto,
  AttrezzatureQueryParams,
  PaginatedResponse,
  AttrezzaturaAssociazione,
  AttrezzaturaAssociazioniQueryParams,
  SetAvailabilityDto,
} from '../../models/attrezzature.model';

export abstract class AttrezzaturePort {
  abstract getList(params?: AttrezzatureQueryParams): Observable<PaginatedResponse<Attrezzatura>>;
  abstract getById(id: number): Observable<Attrezzatura>;
  abstract create(dto: CreateAttrezzaturaDto): Observable<number>;
  abstract update(id: number, dto: UpdateAttrezzaturaDto): Observable<number>;
  abstract setAvailable(id: number): Observable<number>;
  abstract setAvailability(id: number, dto: SetAvailabilityDto): Observable<number>;
  abstract associateToCantiere(id: number, idCantiere: number): Observable<number>;
  abstract endCantiereAssociation(id: number): Observable<number>;
  abstract associateToFornitore(id: number, idFornitore: number, dataUscita: string): Observable<number>;
  abstract endFornitoreAssociation(id: number, dataRitorno: string): Observable<number>;
  abstract getStoricoAssociazioni(params?: AttrezzaturaAssociazioniQueryParams): Observable<PaginatedResponse<AttrezzaturaAssociazione>>;
  abstract archive(id: number, archivia: boolean, dataRitorno?: string): Observable<number>;
}
